import { CampaignAllocation } from "features/MarketingMaterials/api/campaignApi.ts";

export const getCampaignAllocationKey = (
	item: Pick<CampaignAllocation, "campaignId" | "storeAllocationId" | "repAllocationId" | "id" | "selectionKey">
) => item.selectionKey ?? `${item.campaignId}|${item.storeAllocationId ?? item.repAllocationId ?? item.id ?? ""}`;

export const getCampaignSummary = (items: CampaignAllocation[]) => {
	const counts = new Map<string, number>();
	items.forEach((item) => counts.set(item.campaignName, (counts.get(item.campaignName) ?? 0) + 1));
	return [...counts].map(([name, count]) => `${name}${count > 1 ? ` (${count})` : ""}`).join(", ");
};

export const getDisplayCampaignAllocations = (items: CampaignAllocation[]) => {
	const singleQuantityItems: CampaignAllocation[] = [];
	const splitQuantityItems: CampaignAllocation[] = [];

	items.forEach((item) => {
		if ((item.quantity ?? 0) <= 1) {
			singleQuantityItems.push(item);
			return;
		}

		const baseKey = getCampaignAllocationKey(item);
		for (let index = 0; index < item.quantity; index += 1) {
			splitQuantityItems.push({
				...item,
				quantity: 1,
				selectionKey: `${baseKey}|${index + 1}`
			});
		}
	});

	return [...singleQuantityItems, ...splitQuantityItems];
};

export const getCampaignSelections = (items: CampaignAllocation[]) =>
	items
		.map((item) => ({
			campaignId: item.campaignId,
			allocationId: item.storeAllocationId ?? item.repAllocationId ?? item.id ?? ""
		}))
		.filter((item) => item.allocationId);
